import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ReferencesActionType, ReferencesStore } from './ReferencesReducer.types';

// @ts-ignore
const initialState: ReferencesStore = Immutable.fromJS({
  isFetching: false,
  references: null,
  isFetchingItem: false,
  referencesItem: null,
});

const ReferencesReducer = handleActions<any>(
  {
    REQUEST_REFERENCES: (state: ReferencesStore) => state.set('isFetching', true),

    RESPONSE_REFERENCES_FAILURE: (state: ReferencesStore) => state.set('isFetching', false),

    RESPONSE_REFERENCES_SUCCESS: (state: ReferencesStore, action: ReferencesActionType) => {
      const readings = Immutable.fromJS(action.payload);

      return state.set('isFetching', false).set('references', readings);
    },
    REQUEST_REFERENCES_ITEM: (state: ReferencesStore) => state.set('isFetchingItem', true),
    RESPONSE_REFERENCES_ITEM_FAILURE: (state: ReferencesStore) => state.set('isFetchingItem', false),
    RESPONSE_REFERENCES_ITEM_SUCCESS: (state: ReferencesStore, action: ReferencesActionType) =>
      state.set('isFetchingItem', false).set('referencesItem', Immutable.fromJS(action.payload)),
    CLEAN_REFERENCE_ITEM: (state: ReferencesStore) => state.set('isFetchingItem', false).set('referencesItem', null),
    REQUEST_REFERENCES_SUMMARY: (state: ReferencesStore) => state.set('isFetchingSummary', true),

    RESPONSE_REFERENCES_SUMMARY_FAILURE: (state: ReferencesStore) => state.set('isFetchingSummary', false),

    RESPONSE_REFERENCES_SUMMARY_SUCCESS: (state: ReferencesStore, action: ReferencesActionType) => {
      const readings = Immutable.fromJS(action.payload);

      return state.set('isFetchingSummary', false).set('referencesSummary', readings);
    },
  },
  initialState
);

export default ReferencesReducer;
